<template>
    <li >
        <div class="extra-field-wrapper" :class="{blocked: item.isLocked}">
            <div class="col toggle">
                <toggle v-model="item.active"
                        @input="activateExtraField" ></toggle>
            </div>
            <div class="col extra-field-info">
                <div class="test flex">
                    <span>{{item.label}}</span>
                    <i v-if="item.isLocked" class="mdi mdi-star-circle"></i>
                    <div v-if="!item.isDefaultField" class="icons-wrapper">
                        <i v-if="!item.isLocked"
                        class="mdi mdi-square-edit-outline pointer"
                        v-tooltip="$t('message.generics.message.edit')"
                        @click="openEdit(item)"></i>
                        <i v-if="!item.isLocked"
                        class="mdi mdi-delete pointer"
                        v-tooltip="$t('message.generics.message.delete')"
                        @click="showDeleteModal(item)"></i>
                    </div>
                </div>
                <div class="flex">
                    <input type="checkbox" :disabled="!item.active" v-model="item.required" @input="setRequired">
                    <label>{{$t('message.loginPersonalize.message.required')}}</label>
                </div>
            </div>
        </div>


        <confirmation-modal :value="showingControllerDeleteModal"
                            :confirm-label="$t('message.generics.message.confirm')"
                            @confirm="deleteExtraField"
                            @cancel="closeDeleteModal">
            <span slot="heading">
                {{$t('message.loginPersonalize.message.deleteField')}}
            </span>

            <span>
                {{$t('message.loginPersonalize.message.deleteFieldConfirmation')}}
                <br>
                <br>
                <b>{{$t('message.loginPersonalize.message.warning')}}</b>
                {{$t('message.loginPersonalize.message.deletingFieldWarning')}}
            </span>
        </confirmation-modal>

        <captive-forms-modal-extra-fields-form :item="item"
                           :manual-show="showingEditForm"
                           no-activator
                           @submit="onSubmit"
                           @closed="resetShowingEdit" />
    </li>
</template>

<script>
import CaptiveFormsModalExtraFieldsForm from "../form/CaptiveFormsModalExtraFieldsForm.vue"
import Toggle from "@components/Toggle";
import ConfirmationModal from "@components/ConfirmationModal";

export default {
    components: {
        ConfirmationModal,
        CaptiveFormsModalExtraFieldsForm,
        Toggle
    },

    data() {
        return {
            showingControllerDeleteModal: false,
            showingEditForm: false,
        };
    },

    props: {
        item: {
            type: Object,
        },
        captiveLoginTypeId: {
            type: String
        }
    },

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        },
    },

    methods: {
        async deleteExtraField() {
            await this.$api.core.extraField.delete({
                extraFieldId: this.item.id
            });

            this.closeDeleteModal();

            this.$emit("deleted");
        },
        closeDeleteModal() {
            this.showingControllerDeleteModal = false;
        },
        emitEdited() {
            this.$emit("edited");
        },
        openEdit() {
            this.showingEditForm = true;
        },
        resetShowingEdit() {
            this.showingEditForm = false;
        },
        onSubmit() {
            this.resetShowingEdit();
            this.emitEdited();
        },
        showDeleteModal() {
            this.showingControllerDeleteModal = true;
        },
        async activateExtraField() {
            await this.$api.core.extraField.activate({
                extraFieldId: this.item.id,
                captiveLoginTypeId: this.captiveLoginTypeId
            });
            this.emitEdited()
        },
        async setRequired() {
            await this.$api.core.extraField.setRequired({
                extraFieldId: this.item.id,
                captiveLoginTypeId: this.captiveLoginTypeId
            });
        }
    },
};
</script>

<style lang="scss" scoped>
    input {
        cursor: pointer;
    }
    .test{
        width: 170px;
    }
    .icons-wrapper {
        display: flex;
        gap: 4px;
        align-self: baseline;
        margin-left: auto;
    }

    .blocked {
        pointer-events: none;
    }
</style>
